import styles from "./RegisterTermPage.module.css";
import React, {useEffect, useState} from "react";
import {getPolicyAPI, getRegisterAPI, getTermAPI} from "../../../services/term";
import {useNavigate} from "react-router-dom";
import Button from "../../../components/common/button/Button";

//회원가입 규정 페이지
const RegisterTermPage: React.FC = () => {
    const [register, setRegister] = useState("");
    const [term, setTerm] = useState("");
    const [policy, setPolicy] = useState("");
    const [agreements, setAgreements] = useState({
        essential: false,
        optional: false,
        term: false,
        policy: false
    });
    const navigate = useNavigate();

    const fetchRegister = async () => {
        try {
            //회원가입 규정 조회 API
            const register = await getRegisterAPI();
            const term = await getTermAPI();
            const policy = await getPolicyAPI();
            setRegister(register);
            setTerm(term);
            setPolicy(policy);
        } catch (error) {
            console.error('Failed to fetch terms:', error);
        }
    }

    // 선택 항목(optional)을 제외한 필수 항목들만 체크하는 함수
    const areRequiredAgreementsChecked = () => {
        return agreements.essential && agreements.term && agreements.policy;
    };

    useEffect(() => {
        fetchRegister();
    }, []);

    const handleConfirm = (optional: boolean) => {
        if (optional) navigate('/register');
        if (!optional) navigate('/register/essential');
    };

    const handleCheckAll = (checked: boolean) => {
        setAgreements({
            essential: checked,
            optional: checked,
            term: checked,
            policy: checked
        });
    };

    return (
        <div className={styles.container}>
            <div className={styles.formWrapper}>
                <h1 className={styles.title}>회원가입</h1>
                <p className={styles.subtitle}>
                    이미 계정이 있으신가요? {' '}
                    <span
                        className={styles.login}
                        onClick={() => navigate('/login')}
                        style={{cursor: 'pointer'}}
                    >
                        로그인
                    </span>
                </p>

                {/* 이용약관 */}
                <div className={styles.termSection}>
                    <div className={styles.termHeader}>
                        <h3>이용약관</h3>
                        <label className={styles.agreementLabel}>
                            <input
                                type="checkbox"
                                checked={agreements.term}
                                onChange={(e) => setAgreements({
                                    ...agreements,
                                    term: e.target.checked
                                })}
                                className={styles.agreementCheckbox}
                            />
                            <span className={styles.agreementText}>
                                이용약관에 동의합니다
                            </span>
                        </label>
                    </div>
                    <div className={styles.scrollBox}>
                        <pre className={styles.termContent}>{term}</pre>
                    </div>
                </div>

                {/* 개인정보 처리방침 */}
                <div className={styles.termSection}>
                    <div className={styles.termHeader}>
                        <h3>개인정보 처리방침</h3>
                        <label className={styles.agreementLabel}>
                            <input
                                type="checkbox"
                                checked={agreements.policy}
                                onChange={(e) => setAgreements({
                                    ...agreements,
                                    policy: e.target.checked
                                })}
                                className={styles.agreementCheckbox}
                            />
                            <span className={styles.agreementText}>
                                개인정보 처리방침에 동의합니다
                            </span>
                        </label>
                    </div>
                    <div className={styles.scrollBox}>
                        <div
                            className={styles.termContent}
                            dangerouslySetInnerHTML={{__html: policy}}
                        />
                    </div>
                </div>

                {/* 개인정보 이용 동의 */}
                <div className={styles.termSection}>
                    <div className={styles.termHeader}>
                        <h3>개인정보 수집·이용 동의</h3>
                        <div className={styles.labelContainer}>
                            <label className={styles.agreementLabel}>
                                <input
                                    type="checkbox"
                                    checked={agreements.essential}
                                    onChange={(e) => setAgreements({
                                        ...agreements,
                                        essential: e.target.checked
                                    })}
                                    className={styles.agreementCheckbox}
                                />
                                <span className={styles.agreementText}>
                                개인정보 <span className={styles.red}>필수</span>항목 수집·이용에 동의합니다
                            </span>
                            </label>
                            <label className={styles.agreementLabel}>
                                <input
                                    type="checkbox"
                                    checked={agreements.optional}
                                    onChange={(e) => setAgreements({
                                        ...agreements,
                                        optional: e.target.checked
                                    })}
                                    className={styles.agreementCheckbox}
                                />
                                <span className={styles.agreementText}>
                                    개인정보 <span className={styles.blue}>선택</span>항목 수집·이용에 동의합니다
                            </span>
                            </label>
                        </div>
                    </div>
                    <div className={styles.scrollBox}>
                        <pre className={styles.termContent}>{register}</pre>
                    </div>
                </div>

                {/* 전체 동의 체크박스 */}
                <div className={styles.allAgreementWrapper}>
                    <label className={styles.agreementLabel}>
                        <input
                            type="checkbox"
                            checked={Object.values(agreements).every(value => value)}
                            onChange={(e) => handleCheckAll(e.target.checked)}
                            className={styles.agreementCheckbox}
                        />
                        <span className={styles.agreementText}>
                            위 내용을 확인하였으며 모두 동의합니다
                        </span>
                    </label>
                </div>

                <div className={styles.buttons}>
                    <Button
                        type={"button"}
                        variant={"primary"}
                        onClick={() => handleConfirm(agreements.optional)}
                        disabled={!areRequiredAgreementsChecked()}
                    >
                        확인
                    </Button>
                    <Button
                        type={"button"}
                        variant={"secondary"}
                        onClick={() => {
                            navigate('/login')
                        }}
                    >
                        취소
                    </Button>
                </div>
            </div>
        </div>
    )
}
export default RegisterTermPage;